import ActionTypes from '../actionTypes';


const onShowMenu = (show) => {
  return {
    type: ActionTypes.SHOW_MENU_BUTTON,
    payload: {
      showMenu: show,
    },
  }
}

const actions = (dispatch) => {
  return {
    onShowMenu: (show) => dispatch(onShowMenu(show)),
  }
};

export default actions;
